import axios from "axios";
import authorizedAxios from "../../helpers/authorizedAxios";
import { BASE_URL } from "../../helpers/config";
import { showAlert, showToast } from "../../utils/helpers/ShowToast";
import { getReadableApiError } from "../../utils/helpers/apiError";

export const SET_STORES = "SET_STORES";
export const SET_STORE_SETTING = "SET_STORE_SETTING";
export const SET_STORES_LOADING = "SET_STORES_LOADING";
export const SET_STORES_ERROR = "SET_STORES_ERROR";

const setError = (dispatch, error) => {
  dispatch({
    type: SET_STORES_ERROR,
    error: getReadableApiError(error, "Terjadi kesalahan pada data toko."),
  });
};

const appendIfExists = (formData, key, value) => {
  if (value !== undefined && value !== null) {
    formData.append(key, value);
  }
};

const buildStoreFormData = (data, method = null) => {
  const formData = new FormData();

  if (method) {
    formData.append("_method", method);
  }

  [
    "name",
    "legal_name",
    "tagline",
    "email",
    "phone",
    "address",
    "website",
    "instagram",
    "facebook",
    "tiktok",
    "description",
    "invoice_footer",
    "qris_payload",
    "primary_color",
    "is_active",
    "is_multi_outlet",
  ].forEach((field) => appendIfExists(formData, field, data?.[field] ?? ""));

  appendIfExists(formData, "logo", data?.logo_file);
  appendIfExists(formData, "banner", data?.banner_file);
  appendIfExists(formData, "qris_image", data?.qris_image_file);

  return formData;
};

export const fetchStoreSetting = () => async (dispatch) => {
  if (!BASE_URL) {
    return null;
  }

  dispatch({ type: SET_STORES_LOADING, status: true });

  try {
    const response = await axios.get(`${BASE_URL}/stores/current`, {
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });
    const globalSetting = response?.data?.data || response?.data;
    let setting = globalSetting;

    if (localStorage.getItem("auth")) {
      try {
        const outletResponse = await authorizedAxios.get("/outlets/current");
        const outlet = outletResponse?.data?.data;
        if (outlet) {
          setting = {
            ...globalSetting,
            outlet,
            active_outlet_id: outlet.id,
            active_outlet_name: outlet.name,
            qris_payload: outlet.effective_qris_payload || globalSetting?.qris_payload,
            qris_image_path: outlet.effective_qris_image_path || globalSetting?.qris_image_path,
            qris_image: outlet.effective_qris_image_path || globalSetting?.qris_image,
            primary_color: outlet.effective_primary_color || globalSetting?.primary_color,
          };
        }
      } catch {
        // Branding global tetap dapat dipakai bila profil outlet belum tersedia.
      }
    }

    dispatch({ type: SET_STORE_SETTING, data: setting });
    return setting;
  } catch (error) {
    setError(dispatch, error);
    return null;
  } finally {
    dispatch({ type: SET_STORES_LOADING, status: false });
  }
};

export const fetchStores = (limit = 100, page = 1, search = "") => async (dispatch) => {
  dispatch({ type: SET_STORES_LOADING, status: true });

  try {
    const response = await authorizedAxios.get("/stores", { params: { limit, page, search } });
    dispatch({ type: SET_STORES, data: response?.data?.data });
    return response?.data?.data;
  } catch (error) {
    setError(dispatch, error);
    return null;
  } finally {
    dispatch({ type: SET_STORES_LOADING, status: false });
  }
};

export const addStore = (data) => async (dispatch) => {
  dispatch({ type: SET_STORES_LOADING, status: true });

  try {
    const response = await showToast(authorizedAxios.post("/stores", buildStoreFormData(data)), {
      loading: "Menyimpan konfigurasi toko...",
      success: "Konfigurasi toko berhasil ditambahkan!",
      error: (error) => error?.response?.data?.message || "Gagal menyimpan konfigurasi toko!",
    });
    const cmsSync = response?.data?.data?.cms_sync;
    if (cmsSync?.status === "failed") {
      showAlert({ type: "warning", message: cmsSync.message });
    }
    await dispatch(fetchStoreSetting());
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_STORES_LOADING, status: false });
  }
};

export const updateStore = (id, data) => async (dispatch) => {
  dispatch({ type: SET_STORES_LOADING, status: true });

  try {
    const response = await showToast(authorizedAxios.post(`/stores/${id}`, buildStoreFormData(data, "PUT")), {
      loading: "Memperbarui konfigurasi toko...",
      success: "Konfigurasi toko berhasil diperbarui!",
      error: (error) => error?.response?.data?.message || "Gagal memperbarui konfigurasi toko!",
    });
    const cmsSync = response?.data?.data?.cms_sync;
    if (cmsSync?.status === "failed") {
      showAlert({ type: "warning", message: cmsSync.message });
    }
    await dispatch(fetchStoreSetting());
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_STORES_LOADING, status: false });
  }
};
